import { instance, API_PATHS } from '.'

export const getPatientsByFacilityId = (facilityId, limit = 10, skip= 0, search = '') => {
    let URL = `${API_PATHS.datahubPath}/ehx-patients?filter[where][parentCompanyId][eq]=${facilityId}&filter[limit]=${limit}&filter[skip]=${skip}`

    if(search.length > 0) {
        URL += `&filter[where][or][0][firstName][regexp]=/(${search})/i&filter[where][or][1][lastName][regexp]=/(${search})/i&filter[where][or][2][email1][regexp]=/(${search})/i&filter[where][or][3][mainPhone][regexp]=/(${search})/i`
    }

    return instance.get(URL)
}

export const getPatientsByFacilityName = (facilityName, limit = 100, skip= 0, search = '') => {
    let URL = `${API_PATHS.datahubPath}/ehx-patients?filter[where][parentCompanyName][eq]=${facilityName}&filter[limit]=${limit}&filter[skip]=${skip}`

    if(search.length > 0) {
        URL += `&filter[where][or][0][firstName][regexp]=/(${search})/i&filter[where][or][1][lastName][regexp]=/(${search})/i&filter[where][or][2][email1][regexp]=/(${search})/i&filter[where][or][3][mainPhone][regexp]=/(${search})/i`
    }

    return instance.get(URL)
}
export const getPatientsVitalSigns = (id) => {
    return instance.get(`${API_PATHS.datahubPath}/ehx-vital-signs?filter[where][ehxPatientId][eq]=${id}`)
}

export const createPatientsVitalSigns = (data) => {
    return instance.post(`${API_PATHS.datahubPath}/ehx-vital-signs`, data)
}

export const createPatientsVitalSignsPublic = (data) => {
    return instance.post(`${API_PATHS.mainPath}/public/ehx-vital-signs`, data)
}

export const getPatient = (id) => {
	console.log('patient loading - ' + id);
    let URL = `${API_PATHS.datahubPath}/ehx-patients/${id}`;
    console.log(URL);
    return instance.get(URL);
}

//care teams
export const getPatientCareTeams = (id) => {
   let URL = `${API_PATHS.datahubPath}/ehx-care-teams?filter[where][ehxPatientId]=${id}`;
   return instance.get(URL);
}

//	notifications
//data = {pid, fromNumber}
export const sendVitalSignsAckNotification = (data) => {
	let URL = `${API_PATHS.mainPath}/twilio-was/send-vital-signs-acknowledgement`;
	return instance.post(URL, data);
}